import React from "react";
import { HubContextMenu } from "../../components";
import { useFormContext } from "react-hook-form";

const ItemsContextMenu = ({
  idx,
  prefix,
  onAppend = () => {},
  onInsert = () => {},
  onRemove = () => {},
  allowEdit = false,
  ...rest
}) => {
  const { getValues, setValue, watch } = useFormContext();
  const notes = watch(`${prefix}.showNotes`);

  const MENU_ITEMS = [
    {
      id: "notes",
      label: notes ? "Remove Notes" : "Add Notes",
      icon: "Edit",
    },
    ...(allowEdit
      ? [
          {
            id: "add",
            label: "Add Line Item",
            icon: "Plus",
          },
          {
            id: "delete",
            label: "Delete",
            icon: "Trash2",
            color: "redError",
          },
        ]
      : []),
  ];

  const onSelect = (selected) => {
    switch (selected?.id) {
      case "add":
        allowEdit && onAppend();
        break;
      case "notes":
        setValue(`${prefix}.showNotes`, !notes);
        notes && setValue(`${prefix}.notes`, null);
        break;
      case "duplicate":
        const dup = allowEdit && getValues(setValue);
        const payload = {
          price: dup?.price,
          quantity: dup?.quantity,
          units: dup?.units,
        };
        allowEdit && onInsert(payload, idx + 1);
        break;
      case "delete":
        allowEdit && onRemove(idx);
        break;
      default:
        break;
    }
  };

  return (
    <HubContextMenu
      id="display"
      loading={false}
      menuItems={MENU_ITEMS}
      onSelect={onSelect}
      IconButtonProps={{ className: "AddButton", sx: { padding: 0 } }}
      HubIconProps={{ size: 14 }}
      displayOnSelect
      {...rest}
    />
  );
};

export default ItemsContextMenu;
